import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import {
  AttendanceMessageDatasetType,
  AttendanceMessageType,
  SectionUserActivityType,
} from "../../shared/types/attendance";

import { createReplaceAllReducer } from "store/utils";

type AttendanceState = {
  sectionUserActivities: Record<string, SectionUserActivityType>;
};

const defaultState: AttendanceState = {
  sectionUserActivities: {},
};

const initialState = () => defaultState;

const updateUserActivityInstance = (state: AttendanceState, activity: SectionUserActivityType) => {
  state.sectionUserActivities[activity.userId] = activity;
};

export const AttendanceStore = createSlice({
  name: "attendance",
  initialState,
  reducers: {
    // TODO: refactor this when we have a better idea of other data we'll be receiving
    updateAnalytics: (state, action: PayloadAction<SectionUserActivityType[]>) => {
      action.payload.forEach((activity) => {
        updateUserActivityInstance(state, activity);
      });
    },
    updateAnalyticsRecord: (state, action: PayloadAction<AttendanceMessageType>) => {
      if (action.payload.datasetType === AttendanceMessageDatasetType.SECTION_USER_ACTIVITY) {
        updateUserActivityInstance(state, action.payload);
      }
    },
  },
  extraReducers: createReplaceAllReducer<AttendanceState>("attendance", initialState),
});

export const attendanceStateActions = AttendanceStore.actions;
